import _ from "lodash";
import { FETCH_BLOG, INTER_ARTICLE } from "./Blog.action.react";
import { REHYDRATE } from "redux-persist/constants";

const initialBlogState = {
    articles: [],
    editingArticle: {}
};

const BlogReducer = (state = initialBlogState, action) => {
    switch (action.type) {
        case REHYDRATE:
            let blog = action.payload.blog;
            if (blog) {
                return { ...state, ...blog };
            } else {
                return state;
            }
        case FETCH_BLOG:
            if (action.status === "fetching") {
                return { ...state, fetchCompleted: false, error: null };
            } else if (action.status === "success") {
                return { ...state, articles: _.reverse(action.data.articles) };
            } else {
                return { ...state, error: action.err, fetchCompleted: true };
            }
        case INTER_ARTICLE:
            return { ...state, editingArticle: action.data.article };
        default:
            return state;
    }
};

export { BlogReducer };
